// extracted by mini-css-extract-plugin
export default {"wrapper":"twoPlayersIntroduction_wrapper__JcRh2","button":"twoPlayersIntroduction_button__RJNUB"};